/* eslint-disable no-use-before-define */
import React from 'react';
import { isAuth0Enabled } from 'modules/auth/config/authConfig';
import Auth0ProviderWithDynamicConfig from 'Auth0ProviderWithDynamicConfig';
import { CustomAuthProvider } from 'modules/auth/providers/CustomAuthProvider';

export const UnifiedAuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  if (isAuth0Enabled()) {
    return (
      <Auth0ProviderWithDynamicConfig>
        {children}
      </Auth0ProviderWithDynamicConfig>
    );
  }
  return <CustomAuthProvider>{children}</CustomAuthProvider>;
};
